import { useState, useEffect } from "react";
import "./BookCoverPopup.css";
import closeicon from "../Images/close-round-border.svg";
import Loader from "../Pages/Loader"; // Assuming Loader is in Pages based on previous research

interface BookCoverPopupProps {
  show: boolean;
  onClose: () => void;
  imagePath: string;
  bookName: string;
}

const BookCoverPopup = ({ show, onClose, imagePath, bookName }: BookCoverPopupProps) => {
  const [imageLoading, setImageLoading] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (show) {
      setImageLoading(true);
      setIsClosing(false);
    }
  }, [show]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300);
  };

  if (!show && !isClosing) return null;

  const mediumImagePath = imagePath?.replace("small", "medium");

  return (
    <div 
      className={`book-cover-popup-overlay ${isClosing ? 'fade-out' : 'fade-in'}`} 
      onClick={handleClose}
    >
      <div className="book-cover-popup-card" onClick={(e) => e.stopPropagation()}>
        <div className="book-cover-popup-close" onClick={handleClose}>
          <img src={closeicon} alt="close" />
        </div>
        {imageLoading && (
          <div className="book-cover-popup-loader">
            <Loader loading={imageLoading} />
          </div>
        )}
        <img
          src={mediumImagePath}
          alt={bookName}
          className={`book-cover-popup-image ${!imageLoading ? 'loaded' : ''}`}
          onLoad={() => setImageLoading(false)}
          onError={() => setImageLoading(false)}
        />
      </div>
    </div>
  );
};

export default BookCoverPopup;
